exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.department-picker fieldset {\n  background: #F8F8F8 !important;\n}\n.department-picker input {\n  cursor: pointer;\n}\n.department-picker-activator {\n  cursor: pointer;\n}\n.department-group-menu .department-group-menu-column {\n  max-width: 260px;\n  min-width: 200px;\n}\n.department-group-menu .department-group-menu-list {\n  max-height: 360px;\n  overflow-y: auto;\n}", ""]);

// exports
exports.locals = {
	"bodyFontFamily": "\"Roboto\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Helvetica Neue\", \"Microsoft YaHei\", 微软雅黑, STXihei, 华文细黑, \"WenQuanYi Micro Hei\", 文泉驿微米黑, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
	"error": "#E74C3C"
};